import React, { Component } from 'react'
import Btn from '../../../Buttons'
import Slider from 'react-slick'
import { Button, OverlayTrigger, Tooltip, Popover, Modal, Col } from 'react-bootstrap'
import { Link } from 'react-router'
import { ShareButtons, generateShareIcon } from 'react-share'
import FormContact from '../../../../features/commons/ContactForm/ContactForm.container'
import { translate } from 'react-translate'
import { DIST_URL } from '../../../../constants/api'

@translate('Propiedad')
class Propiedad extends Component{

  constructor (props) {
    super(props)

    this.state = {
      show: false,
      showModal: false
    }
    this.toggle = this.toggle.bind(this)
    this.changeViewModal = this.changeViewModal.bind(this)
  }

  toggle(e) {
    e.preventDefault()
    this.setState({show: !this.state.show })
  }

  changeViewModal(e) {
    this.setState({showModal: !this.state.showModal })
    e.preventDefault()
    e.stopPropagation()
  }

  createTooltip(name) {
    return (<Tooltip id='tooltip-property'><p>{name}</p></Tooltip>)
  }

  handleChangeProperty(e, code) {
    //e.preventDefault();
    this.props.loadPropertyDetails(code)
    window.scrollTo(0, 0)
  }

  _renderCategory (id, categories) {
    let category = categories.filter(function (c) {
      return parseInt(c.id) === id
    })
    return category = (category.length > 0) ? category[0].name : ''
  }

  next(e) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line react/no-string-refs
    this.refs.slider2.slickNext()
  }
  previous(e) {
    e.preventDefault()
    e.stopPropagation()
    // eslint-disable-next-line react/no-string-refs
    this.refs.slider2.slickPrev()
  }

  render(){
    const {
      property,
      originPath,
      categories,
      phone,
      t
    } = this.props
    const settings = {
      className: 'property-slider-list',
      dots: false,
      lazyLoad: true,
      arrows: false,
      speed: 400,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 1 } },
        { breakpoint: 1024, settings: { slidesToShow: 1 } }
      ]
    }
    let telephone = 'tel:+5411' + phone.replace('-', '')

    const { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } = ShareButtons

    const FacebookIcon = generateShareIcon('facebook')
    const TwitterIcon = generateShareIcon('twitter')
    const LinkedinIcon = generateShareIcon('linkedin')
    const WhatsappIcon = generateShareIcon('whatsapp')

    if (!property) {
      return (
        <div className='container-fluid'>
           <p>cargando..</p>
        </div>
      )
    }
    else{
      let classes = (property.operation_type.name === 'Alquiler') ?
        'propiedad-tipo' + ' ' + 'rent' : 'propiedad-tipo' + ' ' + 'sale'
      let location = property.short_address
      let divisa_rental = property.rental_currency.name
      let divisa_sale = property.sale_currency.name
      if (property.rental_currency.name == 'Dolar') {
        divisa_rental = 'u$s'
      }
      if (property.sale_currency.name == 'Dolar') {
        divisa_sale = 'u$s'
      }
      let amount = (
        (property.operation_type.name === 'Alquiler' ||
        property.operation_type.name == 'Alquiler temporario')
      ) ?
        divisa_rental + ' ' + (parseInt(property.rental_amount)).toLocaleString('de-DE') :
        divisa_sale + ' ' + (parseInt(property.sale_amount)).toLocaleString('de-DE')
      let operation_types = t('on_for_' + property.operation_type.name)
      let price
      let priceClass = (originPath.name === 'Campos' || !property.web_price) ? 'no-price-box' : ''

      if (
        (property.category_type_id === 9 || !property.web_price) ||
        (
          (property.operation_type.name == 'Alquiler' || property.operation_type.name == 'Alquiler temporario')
          && (property.rental_amount in [0, 1, null, undefined, ''])
        ) ||
        (
          (property.operation_type.name == 'Venta'
          || property.operation_type.name == 'Venta/Alquiler')
          && (property.sale_amount in [0, 1, null, undefined, ''])
        )
      ) {
        price = t('Consultar_precio')
        priceClass = 'no-price-box'
      } else {
        price = amount
      }

      let street = property.address.toLowerCase()
      let floor = property.floor ? ', piso ' + property.floor : ''
      let boxOperations = ''

      let baseUrl = window.location.origin
      let shareUrl = baseUrl + '/' + property.uri
      const title = 'LJ Ramos'
      let description= property.observations

      const popoverShare = (
        <Popover id='popover-share'>
          <WhatsappShareButton
            url={shareUrl}
            title={title}>
            <WhatsappIcon
              size={20}
              round={false} />
          </WhatsappShareButton>
          <FacebookShareButton
            url={shareUrl}
            title={title}
            description={description}
            className=''>
            <FacebookIcon
              size={20}
              round={false} />
          </FacebookShareButton>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className=''>
            <TwitterIcon
              size={20} />
          </TwitterShareButton>
          <LinkedinShareButton
            url={shareUrl}
            title={title}
            className=''>
            <LinkedinIcon
              size={20} />
          </LinkedinShareButton>
          <a
            className='mail-button'
            href={`mailto:?subject=LJRamos propiedad en ${street}${floor}&body=${shareUrl}`}
          >
            <i className='fa fa-envelope'/>
          </a>
        </Popover>
      )
      let generals = [] //array of summary of caracteristics

      if (property.operation_type.name == 'Alquiler temporario' ){
        classes = 'propiedad-tipo' + ' ' + 'rent rent-temp'
      }
      let operationName
      if (property.operation_type.name == 'Venta/Alquiler'){
        boxOperations = (
          <div className='wrapper-left'>
            <div className='propiedad-tipo sale'>
              {t('Venta')}
            </div>
            <div className='propiedad-tipo rent'>
              {t('Alquiler')}
            </div>
          </div>
        )
        operationName = `${t('Venta')} / ${t('Alquiler')}`
      }
      else{
        boxOperations = (
          <div className='wrapper-left'>
            <div className={classes}>
              {t(property.operation_type.name)}
            </div>
          </div>
        )
        operationName = t(property.operation_type.name)
      }

      let contactPhone

      switch (property.property_type.name) {
        case 'Casa' :
        case 'PH':
        case 'Quinta': //housee
          generals = [{value: property.bedrooms, img: DIST_URL+'/assets/images/icons-results/bed.png', overlay: this.createTooltip('Dormitorios')},
                      {value: property.ambients, img: DIST_URL+'/assets/images/icons-results/ambients.png', overlay: this.createTooltip('Ambientes')},
                      {value: ((parseInt(property.land_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                      {value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
          contactPhone = '+5491141141000'
          break
        case 'Departamento' : //apartment
          generals = [{value: property.bedrooms, img: DIST_URL+'/assets/images/icons-results/bed.png', overlay: this.createTooltip('Dormitorios')},
                      {value: property.ambients, img: DIST_URL+'/assets/images/icons-results/ambients.png', overlay: this.createTooltip('Ambientes')},
                      {value: property.garages, img: DIST_URL+'/assets/images/icons-results/garage.png', overlay: this.createTooltip('Estacionamiento')},
                      {value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
          contactPhone = '+5491141141000'
          break
        case 'Terreno' : //terreno
          generals = [{value: ((parseInt(property.land_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                      {value: property.orientation, img: DIST_URL+'/assets/images/icons-results/orientacion.png', overlay: this.createTooltip('Orientación')}]
          contactPhone = '+5491141141000'
          break
        case 'Nave Industrial':
        case 'Depósito':
        case 'Galpón': //industry
          generals = [{value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')},
                      {value: ((parseInt(property.land_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                      {value: property.nave ? parseInt(property.nave) : 0, img: DIST_URL+'/assets/images/icons-results/N.png', overlay: this.createTooltip('Cantidad de Naves')}]
          contactPhone = '+5491147199000'
          break
        case 'Chacra':
        case 'Campo':
        case 'Finca': //fields
          // eslint-disable-next-line no-case-declarations
          let hc = (property.land_area) ? (property.land_area/10000) : 0

          generals = [{value: parseInt(hc), img: DIST_URL+'/assets/images/icons-results/H.png', overlay: this.createTooltip('Hectáreas')}]
          if(property.suitability) {
              generals.push({value: property.suitability , img: DIST_URL+'/assets/images/icons-results/aptitud.png', overlay: this.createTooltip('Aptitud')})
          }
          contactPhone = '+5491141141000'
          break
        case 'Cochera': //cochera
          contactPhone = '+5491141141000'
          break
        case 'Hotel': //hotels
          contactPhone = '+5491141141000'
          break
        case 'Local':
        case 'Fondo de Comercio': //retail
          generals = [{value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
          contactPhone = '+5491141141000'
          break

        case 'Oficina':
        case 'Edificio Comercial': //office/buildings
          generals = [{value: categories ? (this._renderCategory(property.category, categories)) : '' , img: DIST_URL+'/assets/images/icons-results/categoria.png', overlay: this.createTooltip('Categoría')},
                      {value: property.garages, img: DIST_URL+'/assets/images/icons-results/garage.png', overlay: this.createTooltip('Estacionamiento')},
                      {value: ((parseInt(property.covered_area)).toLocaleString('de-DE') + ' m2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
          contactPhone = '+5491141141000'
          break
      }

      switch (property.category_type_id) {
        case 2:
          contactPhone = '+5491147199000'
        break
      }
      switch (property.subsidiary_type_id){
        case 1:
          contactPhone = '+5491141141001'
        break
        case 2:
          contactPhone = '+5491148715991'
        break
        case 3:
          contactPhone = '+54911447199000'
        break
        case 4:
          contactPhone = '+5491148718838'
        break
        case 6:
          contactPhone = '+5491152588818'
        break
        case 7:
          contactPhone = '+5491154676326'
        break
      }
      if (contactPhone == undefined) {
        contactPhone = '+5491141141000'
      }

      var imageContent = (<img src={property.image ? property.image : DIST_URL+'/assets/images/placeholder-gallery.png' } alt={property.title} title={property.title} />)

      if(property.images && property.images.length){
        imageContent = (
          <div>
            <Slider className='property-slider-list' ref='slider2' {...settings}>
              {property.images.map((item, index) =>
                <div key={index} className='prop-image-slider'>
                  <img src={item} alt={property.title} title={property.title} />
                </div>
              )}
            </Slider>
            <div className='slider-buttons'>
              <div className='left-buttons'>
                <a onClick={(e) => {this.previous(e)}}>
                  <i className='fa fa-angle-left fa-3x' aria-hidden='true'></i>
                </a>
              </div>
              <div className='right-buttons'>
                <a onClick={(e) => {this.next(e)}}>
                  <i className='fa fa-angle-right fa-3x' aria-hidden='true'></i>
                </a>
              </div>
            </div>
          </div>
        )
        var imageContentMobile = (
            <div className='prop-image-slider'>
              <img src={property.images[0]} alt={property.title} title={property.title} />
            </div>
        )
      }
      var imageContainer
      if (window.location.pathname == '/propiedades'){
        imageContainer = (
          <div>
            {imageContent}
          </div>
        )
      } else {
        imageContainer = (
          <div>
            <div className='hidden-xs'>
              {imageContent}
            </div>
            <div className='visible-xs'>
              {imageContentMobile}
            </div>
          </div>
        )
      }

      return(
        <div>
          <div className='propiedad-container'>
            <Link to={'/' + property.uri} onClick={(e) => this.handleChangeProperty(e, property.property_code)}>
              <div className='propiedad-img' >
                {imageContainer}
                <div className='wrapper'>
                  {boxOperations}
                  <div className='wrapper-right'>
                    <div className='propiedad-icons'>
                      <OverlayTrigger trigger='click' rootClose placement='top' overlay={popoverShare}>
                        <Button className='btn-icons' ref='target' onClick={(e) => {e.stopPropagation(); this.toggle(e)}}>
                          <i className='fa fa-share-alt fa-lg'></i>
                        </Button>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
            <div className='propiedad-info'>
              <div className='container-fluid'>
                <Link to={'/' + property.uri}>
                  <div className='top-info'>
                    <h3 className='prop-title'>{street}{floor && floor}</h3>
                    <div className='row'>
                      <div className='info' style={{display: 'block'}}>
                        <h2
                          className='zone-title'
                          style={{whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}
                        >
                          <i className='fa fa-map-marker' /> {location}
                        </h2>
                      </div>
                    </div>
                    { property && property.property_type && property.property_type.name &&
                    <div className='row'>
                      <div className='info hidden-xs'>
                        <i className='fa fa-building'></i>
                        <h2 className='property-type-text propertytype'>{property.property_type.name} {operation_types}</h2>
                      </div>
                      <div className='flex-container visible-xs'>
                        <span className='info-mobile'>
                          <i className='fa fa-building'></i>
                          <span className='property-type-text'>{property.property_type.name} {operation_types}</span>
                        </span>
                      </div>
                    </div>
                    }
                  </div>
                  <div className='info info-price'>
                    <p className={priceClass + ' item-price'}>{price}</p>
                    <a className='hidden-xs' onClick={(e) => e.stopPropagation()} target='_blank' href={`https://api.whatsapp.com/send?phone=${contactPhone}&text=${t('Consulta_WhatsApp_Interesado')}: ${property.property_type.name} ${t('Consulta_WhatsApp_En')} ${operationName}%0A${t('Consulta_WhatsApp_Ubicado')} ${street + floor}%0A${t('Consulta_WhatsApp_Codigo')}: ${property.property_code}`}>
                      <div className='whatsapp-info'>
                        <i className='fa fa-whatsapp'></i>
                      </div>
                    </a>
                    <Btn type='text' text={t('Contactar')} classes='btn-primary btn-propiedad hidden-xs' clickButton={(e) => this.changeViewModal(e)} />
                  </div>
                </Link>
                <hr className='hidden-xs'></hr>
                <div className='info detail'>
                  <div className='item-left'>
                    {generals.map((item, index) =>
                      ((item.value !== 0) && (item.value !== undefined)) ? (
                        <div className='item-box' key={index}>
                          <p>{item.value}</p>
                          <OverlayTrigger placement='bottom' overlay={item.overlay}>
                            <Button className='btn-fake'><img src={item.img} alt='LJRamos' /></Button>
                          </OverlayTrigger>
                        </div>
                      ) : ''
                    )}
                  </div>
                  <div className='item-right visible-xs'>
                      <a target='_blank' href={`https://api.whatsapp.com/send?phone=${contactPhone}&text=${t('Consulta_WhatsApp_Interesado')}: ${property.property_type.name} ${t('Consulta_WhatsApp_En')} ${operationName}%0A${t('Consulta_WhatsApp_Ubicado')} ${street + floor}%0A${t('Consulta_WhatsApp_Codigo')}: ${property.property_code}`}><i className='fa fa-whatsapp fa-2x'></i></a>
                      <a href={telephone}><i className='fa fa-phone fa-2x'></i></a>
                      <i className='fa fa-envelope fa-2x' onClick={(e) => this.changeViewModal(e)}></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
              className='modal-contact-form'
              show={this.state.showModal}
              onHide={(e) => this.changeViewModal(e)}
              aria-labelledby='contained-modal-title'
              bsSize='large'
            >
            <Modal.Body>
              <div className='form-box'>
                <div className='form-content form-slider'>
                  <Col md={12} sm={12} className='inputs-form form-modal hidden-xs'>
                    <FormContact textareaDefault={false} property={property} />
                  </Col>
                  <div className='col-md-12 inputs-form visible-xs'>
                    <FormContact textareaDefault={false} property={property} />
                  </div>
                </div>
                <div className='box-close'>
                  <Button type='submit' onClick={(e) => this.changeViewModal(e)} className='btn-close'>
                    <i className='fa fa-times fa-lg'></i>
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )
    }
  }
}

export default Propiedad



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/PropiedadesList/propiedad.js